import type { NavFlags } from "./navConfig";

/**
 * 菜单的「版本 / 模块开关」显示条件（按租户设置，不按权限）：侧栏、顶部导航、命令面板三处共用这一个 hook，保证三处一致。
 * 企业版（公司站）恒为空对象 = 菜单与改动前一致。
 */
export function useNavFlags(): NavFlags {
  const flags: Record<string, boolean> = {};
  return flags;
}
